import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=492f357e"
import script from "./sync.vue?vue&type=script&lang=js"
export * from "./sync.vue?vue&type=script&lang=js"
import style0 from "./sync.vue?vue&type=style&index=0&id=492f357e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports